"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FOCUSED_BORDER_DELTA = exports.FOCUSED_BORDER_SIZE = exports.DEFAULT_BORDER_SIZE = exports.STYLE_VARIANTS = exports.VARIANT_TYPES = void 0;
// TODO: replace with Design System spacing Tokens
const DEFAULT_BORDER_SIZE = 1;
exports.DEFAULT_BORDER_SIZE = DEFAULT_BORDER_SIZE;
const FOCUSED_BORDER_SIZE = 2;
exports.FOCUSED_BORDER_SIZE = FOCUSED_BORDER_SIZE;
const FOCUSED_BORDER_DELTA = FOCUSED_BORDER_SIZE - DEFAULT_BORDER_SIZE;
exports.FOCUSED_BORDER_DELTA = FOCUSED_BORDER_DELTA;
const VARIANT_TYPES = {
  success: 'success',
  warning: 'warning',
  danger: 'danger',
  loading: 'loading'
};
exports.VARIANT_TYPES = VARIANT_TYPES;
const STYLE_VARIANTS = ['success', 'warning', 'danger'];
exports.STYLE_VARIANTS = STYLE_VARIANTS;